"use strict";

require("core-js/modules/es6.string.small");

exports.__esModule = true;
exports.Avatar = exports.GroupAvatarImage = exports.AvatarWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  vertical-align: middle;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  overflow: hidden;\n  align-items: center;\n  background: ", ";\n  font-size: ", ";\n  background-size: cover;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  background-color: ", ";\n  color: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  justify-content: center;\n  align-items: center;\n  font-size: ", ";\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var getAvatarSize = function getAvatarSize(props) {
  return props.small ? "1.4rem" : props.large ? "4.2rem" : props.size || "3rem";
};

var getFontSize = function getFontSize(props) {
  return props.small ? "0.2rem" : props.large ? "2rem" : props.fontSize || "1.2rem";
};

var AvatarWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.backgroundColor || _theme["default"]["default"].primary;
}, function (props) {
  return props.fontColor || _theme["default"]["default"].primaryTextColor;
}, function (props) {
  return getAvatarSize(props);
}, function (props) {
  return getAvatarSize(props);
}, function (props) {
  return getFontSize(props);
});

exports.AvatarWrapper = AvatarWrapper;

var GroupAvatarImage = _styledComponents["default"].div(_templateObject2(), function (props) {
  return "url(" + props.imgSrc + ")";
}, function (props) {
  return props.small ? "0.25rem" : props.large ? "1rem" : props.fontSize || "1rem";
});

exports.GroupAvatarImage = GroupAvatarImage;

var Avatar = _styledComponents["default"].img(_templateObject3(), function (props) {
  return getAvatarSize(props);
}, function (props) {
  return getAvatarSize(props);
});

exports.Avatar = Avatar;